module.exports = __webpack_public_path__ + "img/ico_earncoins_account_more@3x.4c0cc229.png";